import $ from 'jquery'
import axios from 'axios'
import React from 'react'
import getRowsOfTiles from '../../getRowsOfTiles'
import ListView from '../ListView'
import TilesView from '../TilesView'
import ViewLink from './ViewLink'

class KeywordSearch extends React.PureComponent {
  constructor(props) {
    super(props)
    this.el = null
    this.state = {
      isOpen: false,
      keyword: '',
      venues: [],
      view: 'list',
    }
  }
  componentDidMount = () => {
    $('.region-header nav > ul.menu li:last-child a').on('click', this.handleTriggerClick)
  }
  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.isOpen) {
      if (!prevState.isOpen) {
        window.scrollTo(0, 0)
        $('.region-header nav > ul.menu li:last-child a').addClass('selected')
        $(this.el).focus()
        $('body').css('overflow-y', 'hidden')
      }
    }
    else {
      $('.region-header nav > ul.menu li:last-child a').removeClass('selected')
      $(this.el).blur()
      $('body').css('overflow-y', 'auto')
    }
  }
  componentWillUnmount = () => {
    $('.region-header nav > ul.menu li:last-child a')
      .off('click', this.handleTriggerClick)
      .removeClass('selected')
    $(this.el).blur()
    $('body').css('overflow-y', 'auto')
  }
  handleChange = (event) => {
    this.setState({
      keyword: event.target.value,
    })
    axios.get('/api/search', {
      params: {
        keyword: event.target.value,
      },
    }).then((res) => {
      this.setState({
        venues: res.data.venues,
      })
    })
  }
  handleItemClick = () => {
  }
  handleKeyDown = (event) => {
    if (event.which === 27) {
      this.setState({
        isOpen: false,
        keyword: '',
        venues: [],
        view: 'list',
      })
    }
  }
  handleTriggerClick = (event) => {
    event.preventDefault()
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
      keyword: '',
      venues: [],
      view: 'list',
    }))
  }
  handleViewClick = (view) => {
    this.setState({
      view,
    })
  }
  render() {
    if (!this.state.isOpen) {
      return null
    }
    return (
      <div className="keyword-search">
        <div className="input">
          <div className="inner">
            <input
              onChange={this.handleChange}
              onKeyDown={this.handleKeyDown}
              placeholder="Search"
              ref={(el) => {
                this.el = el
              }}
              type="text"
              value={this.state.keyword}
            />
          </div>
        </div>
        {this.state.venues.length > 0 &&
          <div className="view-links">
            <div className="inner">
              <ViewLink
                onClick={this.handleViewClick}
                selectedView={this.state.view}
                view="list"
              />
              <ViewLink
                onClick={this.handleViewClick}
                selectedView={this.state.view}
                view="tiles"
              />
            </div>
          </div>
        }
        {this.state.venues.length > 0 &&
          <div className="results">
            <div className="inner">
              {this.state.view === 'list' &&
                <ListView
                  listItems={this.state.venues}
                  onClick={this.handleItemClick}
                  useWindowScroller={false}
                />
              }
              {this.state.view === 'tiles' &&
                <TilesView
                  onClick={this.handleItemClick}
                  rowsOfTiles={getRowsOfTiles(this.state.venues, false)}
                  useWindowScroller={false}
                  venues={this.state.venues}
                />
              }
            </div>
          </div>
        }
      </div>
    )
  }
}
KeywordSearch.propTypes = {
}

export default KeywordSearch
